import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Autocomplete } from '@material-ui/lab';
import { Grid, TextField, Button } from '@material-ui/core';
import { getCategories } from '../../actions/admin/category';
import Constants from '../../common/constants';
import PostList from './postList';
import apiService from '../../services.js/apiService';

const rows = [10, 15, 20, 25];

const Info = ({ activeStep, onActiveStepChanged, adType, adUrl, onChangedAdUrl, postId,
  onChangedPostId, getCategories }) => {
  const [postsLoaded, setPostsLoaded] = React.useState(false);
  const [categoriesLoaded, setCategoriesLoaded] = React.useState(false);
  const [url, setUrl] = React.useState(adUrl);
  const [id, setId] = React.useState(postId);
  const [posts, setPosts] = React.useState([]);
  const [totalCount, setTotalCount] = React.useState(0);
  const [title, setTitle] = React.useState('');
  const [brand, setBrand] = React.useState('');
  const [categories, setCategories] = React.useState([]);
  const [categoryId, setCategoryId] = React.useState('');
  const [pageNo, setPageNo] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(rows[0]);

  const fetchPosts = async (params) => {
    const response = await apiService.getPostsByParamsForAds({ ...params, status: Constants.Status.Live });
    if (response) {
      setTotalCount(response.totalCount);
      setPosts(response.rows ? response.rows : []);
      setPostsLoaded(true);
    }
  };

  const fetchCategories = async (params) => {
    const response = await getCategories();
    if (response) {
      setCategories(response || []);
      setCategoriesLoaded(true);
    }
  };

  useEffect(() => {
    fetchPosts({ pageNo, pageSize });
    fetchCategories();
  }, []);

  useEffect(() => {
    setPageNo(0);
    handleSearch();
  }, [title, brand, categoryId]);

  const handleSearch = () => {
    const params = {
      brand,
      title,
      categoryId,
    };
    fetchPosts({ ...params, pageNo: 0, pageSize });
  };

  if (adType === Constants.AdType.Url) {
    return (
      <Grid container direction="column" spacing={3}>
        <Grid item>
          <h5>URL</h5>
          <TextField
            autoComplete="off"
            fullWidth
            name="url"
            placeholder="URL"
            value={url || ''}
            onChange={(e) => {
              setUrl(e.target.value);
              onChangedAdUrl(e.target.value);
            }}
          />
        </Grid>
        <div
          className="d-flex"
          style={{
            justifyContent: 'flex-end',
            marginTop:      30,
          }}
        >
          <Button
            disabled={!!(url === null || url === '')}
            onClick={() => { onActiveStepChanged(activeStep + 1); }}
            variant="contained"
            color="default"
          >
            Next
          </Button>
        </div>
      </Grid>
    );
  } else if (postsLoaded && categoriesLoaded) {
    return (
      <div>
        <div className="row" style={{ marginBottom: 10 }}>
          <TextField
            style={{ marginTop: 10 }}
            label="Search Title"
            id="outlined-size-small"
            name="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            variant="outlined"
            size="small"
            autoComplete="off"
          />
          &nbsp;
          <TextField
            style={{ marginTop: 10 }}
            label="Search Brand"
            id="outlined-size-small"
            name="brand"
            value={brand}
            onChange={(e) => setBrand(e.target.value)}
            variant="outlined"
            size="small"
            autoComplete="off"
          />
          &nbsp;
          <Autocomplete
            style={{ width: 400, marginTop: 10 }}
            size="small"
            id="grouped-demo"
            options={categories}
            groupBy={(option) => option.group}
            onChange={(e, value) => (value ? setCategoryId(value.id) : setCategoryId(''))}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField {...params} label="Search Category" variant="outlined" />}
          />
        </div>
        <div className="row">
          <PostList
            rows={rows}
            pageSize={pageSize}
            pageNo={pageNo}
            posts={posts}
            totalCount={totalCount}
            postId={id}
            onChangedPostId={
              (e) => {
                  setId(e);
                  onChangedPostId(e);
              }
            }
            onChangedTable={(page, rows) => {
                setPageNo(page);
                setPageSize(rows);
                fetchPosts({ brand, title, categoryId, pageNo: page, pageSize: rows });
            }}
          />
        </div>
        <div
          className="row"
          style={{
            justifyContent: 'flex-end',
            marginTop:      30,
          }}
        >
          <Button
            disabled={!!(postId === null || postId === '')}
            onClick={() => { onActiveStepChanged(activeStep + 1); }}
            variant="contained"
            color="default"
          >
            Next
          </Button>
        </div>
      </div>
    );
  } else {
    return null;
  }
};
export default connect(null, { getCategories })(Info);
